const pages = {
  pages: {
    home: 'Home',
    reports: 'Reports',
    user: 'User',
    users: 'Users',
    bonus: 'Bonus Wallet',
    bonusProgram: 'Bonus Program',
    bonusEngine: 'Bonus Engine',
    offer: 'Offer',
    offers: 'Offers',
    bonusOffer: 'Bonus Offer',
    bonusOffers: 'Bonus Offers',
    settings: 'Settings',
    userManagement: 'Manage Users',
    wallet: 'Bonus Wallet',
    transactions: 'Transactions',
    listTransactions: 'Transactions By Wallet ID',
    listContributions: 'Contributions',
    freePlayContributions: 'Free Play Contributions',
    sportsROCalculator: 'Sports RO Calculator',
    create: 'Create',
    update: 'Update',
    players: 'Players',
  },
}

export default pages
